import { render, staticRenderFns } from "./MatchList.vue?vue&type=template&id=766bd2e2"
import script from "./MatchList.vue?vue&type=script&lang=js"
export * from "./MatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports